var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EditFilled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.1881 6.53769L15.6073 9.95694M4.06738 18.0777H7.48663L16.4622 9.10213C16.6867 8.87762 16.8648 8.61108 16.9863 8.31775C17.1078 8.02441 17.1703 7.71001 17.1703 7.39251C17.1703 7.075 17.1078 6.7606 16.9863 6.46726C16.8648 6.17393 16.6867 5.90739 16.4622 5.68288C16.2376 5.45837 15.9711 5.28028 15.6778 5.15877C15.3844 5.03727 15.07 4.97473 14.7525 4.97473C14.435 4.97473 14.1206 5.03727 13.8273 5.15877C13.534 5.28028 13.2674 5.45837 13.0429 5.68288L4.06738 14.6584V18.0777Z",
    stroke: "white",
    strokeOpacity: 0.56,
    strokeWidth: 1.57811,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditFilled);
export default __webpack_public_path__ + "static/media/EditFilled.0df45a13f42091651888eb64dd23c80c.svg";
export { ForwardRef as ReactComponent };